import { sleep } from 'common/util'
import { BuildInfo } from 'common/api/v1/types'
import { enqueueNewVersionAvailableSnackbar } from './notificationActions'
import { ThunkApi } from '../../store'
import { mixpanel } from '../../mixpanel'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { areComparable, releaseTagToNumber } from 'common/buildInfoUtils'

const newVersionSnackbarVisible = () => document.querySelector('[data-reload-page-new-version]') !== null

export const getBuildInfo = createAsyncThunk<BuildInfo, void, ThunkApi>(
  'buildInfo/readBuildInfo',
  async (_, { dispatch, getState, extra: { api } }) => {
    const { buildInfo: currentBuildInfo } = getState().buildInfoReducer
    const buildInfo = await api.buildInfoApi.readBuildInfo()

    if (currentBuildInfo && areComparable(currentBuildInfo.release, buildInfo.release)) {
      const current = releaseTagToNumber(currentBuildInfo.release)
      const release = releaseTagToNumber(buildInfo.release)

      if (current < release && !newVersionSnackbarVisible()) {
        dispatch(enqueueNewVersionAvailableSnackbar())
      }
    }

    return buildInfo
  },
)

let initialized = false
export const initBuildInfo = createAsyncThunk<void, void, ThunkApi>(
  'buildInfo/initBuildInfo',
  async (_, { dispatch }) => {
    if (initialized) {
      return
    }

    initialized = true
    while (true) {
      try {
        // Await so it doesn't queue up requests if the backend is slow
        const buildInfo = await dispatch(getBuildInfo()).unwrap()
        mixpanel.addBuildInfo(buildInfo)
      } catch (e) {
        // oxlint-disable-next-line no-console
        console.error(e)
      }
      await sleep(30_000)
    }
  },
)
